export const vDraggable = {
  mounted(el) {
    const titleBar = el.querySelector('.v-card-title')
    if (!titleBar) return

    let isMouseDown = false
    let currentX = 0
    let currentY = 0
    let initialX = 0
    let initialY = 0

    titleBar.style.cursor = 'move'
    titleBar.style.userSelect = 'none'

    const mouseDownHandler = (e) => {
      isMouseDown = true
      initialX = e.clientX - currentX
      initialY = e.clientY - currentY
    }

    const mouseMoveHandler = (e) => {
      if (!isMouseDown) return

      currentX = e.clientX - initialX
      currentY = e.clientY - initialY

      el.style.transform = `translate(${currentX}px, ${currentY}px)`
    }

    const mouseUpHandler = () => {
      isMouseDown = false
    }

    titleBar.addEventListener('mousedown', mouseDownHandler)
    document.addEventListener('mousemove', mouseMoveHandler)
    document.addEventListener('mouseup', mouseUpHandler)

    // Cleanup on unmount
    el._draggableCleanup = () => {
      titleBar.removeEventListener('mousedown', mouseDownHandler)
      document.removeEventListener('mousemove', mouseMoveHandler)
      document.removeEventListener('mouseup', mouseUpHandler)
    }
  },

  unmounted(el) {
    if (el._draggableCleanup) {
      el._draggableCleanup()
    }
  }
}
